import http from 'utils/http'

const getCampaignRate = idBusiness => http.get(`/order/v1/order/campaingrate/${idBusiness}`)


export default {
  getCampaignRate
}



// WEBPACK FOOTER //
// ./src/services/campaignRateService.js